module.exports = __webpack_public_path__ + "img/selected2-min.aabe6b9d.png";